/**
 * state.js — Stato condiviso della prenotazione e variabili wizard.
 * Mirror di sharedObjectFinal / define.dart della app Flutter.
 */

// Dati della prenotazione in costruzione
const BookingState = {
    reservation_type: 'andata',   // andata | andata_ritorno_attesa | andata_ritorno_richiamata | andata_ritorno_orari_def

    start_date:  '',              // dd/mm/yyyy
    return_date: '',
    start_time:  '',              // HH:MM
    return_time: '',

    start_address:       '',
    start_address_lat:   '',
    start_address_lng:   '',
    start_address_types: [],   // Google Places types (es. ['street_address', 'geocode'])
    start_address_opts: {
        type:      '',   // tipologia luogo
        barriere:  '',
        abit_type: '',   // piano abitazione
        ascensore: '',   // 'si' | ''
        sedia:     '',   // 'si' | ''
        sedia_type:'',
        jolly:     '',   // 'si' | ''
        note:      '',
        photos:    [],
    },

    end_address:       '',
    end_address_lat:   '',
    end_address_lng:   '',
    end_address_types: [],   // Google Places types
    end_address_opts: {
        type:      '',
        barriere:  '',
        abit_type: '',
        ascensore: '',
        sedia:     '',
        sedia_type:'',
        jolly:     '',
        note:      '',
        photos:    [],
    },

    seat:       1,   // persone in sedia a rotelle
    seat_guest: 1,   // accompagnatori

    client: {
        name:           '',
        lastname:       '',
        address:        '',
        address_country:'IT', // codice ISO paese (IT = Italia)
        cf:             '',
        email:          '',
        phone:          '',
        privacy:        '',   // '1' = accettato
    },

    fly_number: '',
    train_name: '',
    boat_name:  '',

    PaymentMethod:      '',  // Stripe paymentMethod.id
    paymentMethodLabel: '',  // 'Carta di credito' | 'POS' | 'Contanti'
    directionsData:     null, // risposta maps.getDirectionsService
    mapImageUrl:        '',   // URL immagine maps.getMapsStatic
    Summary:            {},   // risposta getSummaryReservation
};

// ── Variabili di flusso wizard ──────────────────────────────────
let currentTab        = 0;
let readyForTrack     = false;   // disponibilità verificata via API
let readyForSummary   = false;   // preventivo già richiesto
let readyForPayment   = false;   // preventivo ricevuto con successo
let isInPayment       = false;   // pagamento in corso
let availabilityTimer = null;    // debounce check disponibilità
